import { render, staticRenderFns } from "./BracketHeaderBtn.vue?vue&type=template&id=ab583b58&"
import script from "./BracketHeaderBtn.vue?vue&type=script&lang=js&"
export * from "./BracketHeaderBtn.vue?vue&type=script&lang=js&"
import style0 from "./BracketHeaderBtn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports